import _ from 'lodash';
import ProjectsData from '../constants/projects.json';
import ContentsData from '../constants/contents.json';
import ContentPicsData from '../constants/contentPics.json';

const buildContentPic = (record) => {
  const { fields: {
    engTitle,
    chtTitle,
    engContent,
    chtContent,
    carousel,
    videoControl,
  } } = record;

  const pic = {
    engTitle,
    chtTitle,
    engContent,
    chtContent,
    carousel,
    videoControl,
    attachments: [],
  };
  if (!record.fields.attachments) {
    return null;
  }
  record.fields.attachments.forEach((attachment) => {
    if (attachment.thumbnails && attachment.thumbnails.large) {
      var { url, type } = attachment;
      var { width, height } = attachment.thumbnails.large;
      pic.attachments.push({ url, thumbnailsUrl: attachment.thumbnails.large.url, type, width, height });
    } else {
      const { url, type } = attachment;
      pic.attachments.push({ url, type });
    }
  });

  // weird sequence problem of airtable
  pic.attachments = pic.attachments.reverse();

  return pic;
};

const getProject = (id) => {
  const projectData = _.find(ProjectsData.records, ['id', id]);
  if (!projectData) {
    return null;
  }

  const { fields } = projectData;

  const project = {
    engName: fields.engName,
    chtName: fields.chtName,
    contentId: fields.content[0],
    tags: fields.tagList.split(','),
  }

  if (fields.linkPic) {
    project.linkPicURL = fields.linkPic[0].url;
  }

  return project;
};

const buildContent = (record) => {
  const { fields } = record;

  const content = {
    engName: fields.engName,
    chtName: fields.chtName,
    engContent: fields.engContent,
    chtContent: fields.chtContent,
    tagListStr: fields.tagListStr,
    infos: {
      engScope: fields.engScope,
      chtScope: fields.chtScope,
      engPartner: fields.engPartner,
      chtPartner: fields.chtPartner,
      engClient: fields.engClient,
      chtClient: fields.chtClient,
    },
  };

  // weird sequence problem of airtable
  content.pics = fields.pics.slice(0).reverse().map(id => {
    const pic = _.find(ContentPicsData.records, ['id', id]);
    if (pic) {
      return buildContentPic(pic);
    }

    return null;
  });

  _.remove(content.pics, pic => pic === null);

  const relatedProjects = fields.relatedProjects || [];
  content.relatedProjects = relatedProjects.slice(0).reverse().map(id => getProject(id));

  return content;
};

const getContent = (engName) => {
  const contentData = _.find(ContentsData.records, record => {
    const recordEngName = record.fields.engName || '';
    return recordEngName.trim() === engName.trim()
  });
  if (!contentData) {
    return null;
  }
  return buildContent(contentData);
};

export default {
  getContent,
};



// WEBPACK FOOTER //
// ./src/utils/content.js